<div class="mpp-page-header__title icon"
     [innerHTML]="heading"
     [ngClass]="icon"
></div>

<div class="mpp-page-header__description" [innerHTML]="description"></div>
